export var HttpMethod = /*#__PURE__*/function (HttpMethod) {
  HttpMethod["GET"] = "get";
  HttpMethod["POST"] = "post";
  HttpMethod["PATCH"] = "patch";
  HttpMethod["DELETE"] = "delete";
  return HttpMethod;
}({});